var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.html),expression:"html"}]})}
var staticRenderFns = []

export { render, staticRenderFns }